import { NgModule } from '@angular/core';
import { SharedModule } from 'app/components/shared.module';
import { FullscreenLayout, FullscreenLayoutComponent } from 'app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.component';
import { SectionModule } from 'app/views/presentations/layouts/layouts/section.module';
import { LayoutWrapperModule } from 'app/views/presentations/layouts/layoutWrapper.module';

@NgModule({
    imports: [
        SharedModule,
        SectionModule,
        LayoutWrapperModule.wrapLayout(FullscreenLayout)
    ],
    declarations: [
        FullscreenLayoutComponent
    ],
    entryComponents: [
        FullscreenLayoutComponent
    ]
})
export class FullscreenLayoutModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/layouts/layouts/fullscreenLayout/fullscreenLayout.module.ts